import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { startsWith } from 'src/utils';
import { childrenPropType } from 'src/lib/prop-types';

const isUrlInternal = startsWith('/');

export function ALinkButton({ url, external, color, className, children, ...props }) {
  const classes = `px-5 py-3 mb-2 text-center text-${color}-800 bg-${color}-100 hover:bg-${color}-200 hover:text-${color}-900 rounded-md ${className}`;

  if (external) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className={classes} {...props}>
        {children}
      </a>
    );
  }

  if (isUrlInternal(url)) {
    const to = url;
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a href={url} className={classes} {...props}>
      {children}
    </a>
  );
}

ALinkButton.propTypes = {
  url: PropTypes.string.isRequired,
  external: PropTypes.bool,
  color: PropTypes.oneOf(['gray', 'red', 'orange', 'yellow', 'green', 'teal', 'blue', 'indigo', 'purple', 'pink']),
  className: PropTypes.string,
  children: childrenPropType.isRequired,
};

ALinkButton.defaultProps = {
  external: false,
  color: 'indigo',
  className: null,
};
